import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedOnConditionElement } from 'site-modules/shared/components/animated-on-condition-element/animated-on-condition-element';
import { AnimatedOnScrollElement } from 'site-modules/shared/components/animated-on-scroll-element/animated-on-scroll-element';

import './slide-left.scss';

export function SlideLeftOnCondition({ className = '', children = null, shouldAnimate = false }) {
  return (
    <AnimatedOnConditionElement
      className={className}
      animationClassNames={['slide-left']}
      shouldAnimate={shouldAnimate}
    >
      {children}
    </AnimatedOnConditionElement>
  );
}

SlideLeftOnCondition.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  shouldAnimate: PropTypes.bool,
};

export function SlideLeftOnScroll({ className = '', children = null }) {
  return (
    <AnimatedOnScrollElement className={className} animationClassNames={['slide-left']}>
      {children}
    </AnimatedOnScrollElement>
  );
}

SlideLeftOnScroll.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
